import { connect, MapStateToProps } from "react-redux";

import { IAppState, QAProps } from "@multiweb/types/react";
import { NavigationSection } from "../../navigation";
import { getOpenedFormInfo } from "../../openedItems";
import { OpenedItemComponent, OpenedItemComponentProps } from "../OpenedItemComponent";

export type OpenedItemProps = {
    readonly formInstanceId: string;
    /** Sekce, ve které je profil vykreslený. Slouží pro určování zaměření. */
    section: NavigationSection;
} & QAProps;

type StateProps = Pick<OpenedItemComponentProps, "openedFormInfo">;

const mapStateToProps: MapStateToProps<StateProps, OpenedItemProps, IAppState> = (state, { formInstanceId }) => ({
    openedFormInfo: getOpenedFormInfo(state, formInstanceId),
});

export const OpenedItem = connect(mapStateToProps)(OpenedItemComponent);
